import { FC } from 'react';
import { Navigate } from 'react-router-dom';

export const HomePage: FC = () => <Navigate to="/login" />;
